import DOMPurify from 'dompurify';
import { FC } from 'react';

import { SAFE_HTML_SANITIZER_CONFIG } from '@/shared/config';

// Prevent reverse tabnabbing: a link with target must not expose window.opener
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.hasAttribute('target')) {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

type SafeHtmlProps = {
  html: string;
  className?: string;
};

export const SafeHtml: FC<SafeHtmlProps> = (props) => {
  const { html, className } = props;

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(html, SAFE_HTML_SANITIZER_CONFIG),
      }}
    />
  );
};
